<template>
  <div class="lg:text-lg text-lg bg-white drop-shadow-lg shadow-2xl p-8">
    <div class="md:flex justify-between grid grid-cols-1 mb-12">
      <img class="h-12" :src="getImg()" alt="shottracker logo" />

      <div class="text-gray-700 md:text-right md:mt-0 mt-5">
        <p class="uppercase">{{ form.role }}</p>
        <a
          :href="applyLink"
          target="_blank"
          class="
            text-STorange
            uppercase
            lg:text-2xl
            md:text-2xl
            sm:text-lg
            font-AvenirBlackFont
            underline
          "
          >APPLY HERE
        </a>
        <p class="uppercase">
          send resume to:
          <span class="hover:underline">
            <a href="mailto: careers@shottracker.com"
              >careers@shottracker.com</a
            ></span
          >
        </p>
      </div>
    </div>

    <div>
      <p class="mb-3">Open Position Summary</p>
      <div class="w-1/3 border-b-2 border-black" />
    </div>

    <div class="mt-5">
      <p>Role Overview:</p>
      <MarkdownPreview :text="form.overview" />
    </div>

    <div class="mt-5">
      <p>Responsibilities:</p>
      <MarkdownPreview :text="form.responsibilities" />
    </div>

    <div class="mt-5">
      <p>Qualifications:</p>
      <MarkdownPreview :text="form.skills" />
    </div>

    <div v-if="form.reportsTo" class="mt-5">
      <p>Travel:</p>
      <MarkdownPreview :text="form.reportsTo" />
    </div>

    <div v-if="form.location" class="mt-5">
      <p>Location:</p>
      <MarkdownPreview :text="form.location" />
    </div>

    <div class="mt-5">
      <p>Benefits:</p>
      <MarkdownPreview :text="form.compensation" />
    </div>
  </div>
</template>

<script>
import { generateFullPath, isValidHttpURL } from '../../utils/fileHelpers'
import MarkdownPreview from '../MarkdownPreview.vue'

export default {
  name: 'JobPostingsPreview',
  props: {
    form: Object,
  },
  components: {
    MarkdownPreview,
  },

  computed: {
    applyLink() {
      const defaultLink =
        'https://docs.google.com/forms/d/e/1FAIpQLScjdUnqrznmBr89zlN_K0olp3xdXh5hKtbnj3xYH0MnD4JWXw/viewform'

      if (isValidHttpURL(this.form.applyLink)) {
        return this.form.applyLink
      } else {
        return defaultLink
      }
    },
  },

  methods: {
    getImg() {
      return generateFullPath('/images/logos/ShotTracker3_180.png')
    },
  },

  mounted() {
    this.$gtag.pageview({ page_title: this.form.role })
  },
}
</script>

<style scoped>
p {
  @apply font-AvenirBlackFont;
}
</style>
